<template>
    <form>
        <div class="form_row">
            <label class="form_label">
                {{ $t('contentBuilder.contactForm.fullNameLabel') }}
            </label>

            <input
                v-model="form.fullName"
                class="form_control"
                :placeholder="
                    $t('contentBuilder.contactForm.fullNamePlaceholder')
                "
                :class="{
                    'is-invalid': !!getError('fullName')
                }"
                type="text"
            />

            <div class="invalid-feedback">
                {{ getError('fullName') }}
            </div>
        </div>

        <div class="form_row">
            <label class="form_label">
                {{ $t('contentBuilder.contactForm.emailLabel') }}
            </label>

            <input
                v-model="form.email"
                class="form_control"
                :placeholder="$t('contentBuilder.contactForm.emailPlaceholder')"
                :class="{
                    'is-invalid': !!getError('email')
                }"
                type="text"
            />

            <div class="invalid-feedback">
                {{ getError('email') }}
            </div>
        </div>

        <div class="form_row">
            <label class="form_label">
                {{ $t('contentBuilder.contactForm.phoneLabel') }}
            </label>

            <input
                v-model="form.phone"
                class="form_control"
                :placeholder="$t('contentBuilder.contactForm.phonePlaceholder')"
                :class="{
                    'is-invalid': !!getError('phone')
                }"
                type="text"
            />

            <div class="invalid-feedback">
                {{ getError('phone') }}
            </div>
        </div>

        <div class="btn_row">
            <button class="btn btn_gray" type="button" @click="$emit('submit')">
                {{ $t('contentBuilder.contactForm.submit') }}
            </button>
        </div>
    </form>
</template>

<script>
import BaseForm from './BaseForm';

export default {
    extends: BaseForm,

    watch: {
        value(value) {
            this.form = value;
        }
    }
};
</script>
